import React from 'react';
import { Menu as JetMenu } from "@randajan/jet-react/dom/menu";

import { navigationItems } from "../../../pages";

import "./Menu.scss";
import { Link } from '@randajan/jet-react/dom/link';
import Hamburger from "./menu.svg";
import { Img } from '@randajan/jet-react/dom/img';
import { screen } from '@randajan/jet-react/base/screen';
import page from "@randajan/jet-react/base/page";



import jet from "@randajan/jet-react";

const contactHashKey = "hash.contact";
const contactHashValue = "up";

const getLinkKind = to => String(to).startsWith("#") ? "action" : "route";

const isMenuLinkCurrent = (to, kind)=>{
    if (kind === "action") { return page.get(contactHashKey) === contactHashValue; }
    return page.get("pathname") === to;
}


export const MenuLink = (props)=>{
    const menu = JetMenu.use();
    page.use();

    const { className, onClick, to } = props;
    const kind = getLinkKind(to);
    const state = isMenuLinkCurrent(to, kind) ? "current" : "ready";
    const actions = [menu?.blur, onClick];

    return (
        <Link
            {...props}
            className={jet.melt(["Menu__link", className], " ")}
            data-menu-kind={kind}
            data-menu-state={state}
            onClick={(ev)=>{jet.run(actions, ev)}}
        />
    );
}


export const Menu = (props)=>{
    const [w960] = screen.use("960w");

    
    return (
        <JetMenu flat={w960.get()} trigger={<Img src={Hamburger}/>} transition={500} position="bottom" keepMounted>
            {navigationItems.map(({to, title})=><MenuLink key={to} to={to}>{title}</MenuLink>)}
        </JetMenu>
    )
}

